import { combineEpics } from 'redux-observable';
import { createOnboardingEpic } from './create-onboarding';
import { onboardingCreatedEpic } from './onboarding-created';

const onboardingEpic = combineEpics(
  createOnboardingEpic,
  onboardingCreatedEpic
);

export default onboardingEpic;
